import get from 'lodash/get';
import { ref, computed } from 'vue';

// Create shared state across components
const entry = ref(null);

/**
 * Composable for handling routine functionality
 * This replaces the Routine mixin
 */
export const useRoutine = (routine = null) => {
  const routineTitle = computed(() => {
    return routine?.title;
  });

  const routineDuration = computed(() => {
    return `${routine?.duration} Min`;
  });
  const routineExerciseCount = computed(() => {
    return routine?.exerciseCount;
  });
  const routineDifficulty = computed(() => {
    return routine ? get(routine, 'difficulty[0].title', '') : null;
  });
  const routineVideo = computed(() => {
    return routine ? get(routine, 'video[0]') : null;
  });
  const routineImage = computed(() => {
    return routine ? get(routine, 'image[0]') : null;
  });

  // Helper function to parse exercise properties
  const parseExerciseProperties = (properties) => {
    if (properties && properties.length) {
      return properties.map((prop) => prop.title).join(', ');
    }
    return '';
  };

  return {
    // State
    entry,
    routineDuration,
    routineExerciseCount,
    routineDifficulty,
    routineVideo,
    routineImage,
    routineTitle,

    // Methods
    parseExerciseProperties,
  };
};
